/**
 * Reusable component for editing ResourceLinks
 *
 * NOTE: The Yote _resource assigned to a given ResourceLink is immutable and
 * passed in as a prop to this component.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

const ProgramResourceLinkListItem = ({resourceLink}) => {
  return (
    <div className="resource-link-item">
      <div className="-display-name tooltip">
        <div className="-tip-text -bottom">
          <div>
            <a href={resourceLink.downloadUrl ? resourceLink.downloadUrl : resourceLink.url} target="_blank">{resourceLink.downloadUrl ? resourceLink.downloadUrl : resourceLink.url}</a>
          </div>
        </div>
        <div>{resourceLink.name}</div>
      </div>
    </div>
  )
}

ProgramResourceLinkListItem.propTypes = {
  resourceLink: PropTypes.object.isRequired
}

export default ProgramResourceLinkListItem;



// WEBPACK FOOTER //
// modules/resourceLink/components/ProgramResourceLinkListItem.js.jsx